
export default {
    namespaced: true,
    state: {
        login: '',
        password: '',
        isFail: false,
        isLoad: false


    },
    getters: {
        IS_LOAD: state => {
            return state.isLoad;
        },
        IS_FAIL: state => {
            return state.isFail;
        },
        LOGIN: state => {
            return state.login;
        },
        PASSWORD: state => {
            return state.password;
        }
    },
    mutations: {
        IS_LOAD: (state, payload) => {
            return state.isLoad = payload;
        },
        IS_FAIL: (state, payload) => {
            return state.isFail = payload;
        },
        LOGIN: (state, payload) => {
            return state.login = payload;
        },
        PASSWORD: (state, payload) => {
            return state.password = payload;
        }
    },
    actions: {
        SEND_LOGIN: async ({state, commit, getters, rootGetters }, payload) => {
            let formData = new FormData();

            formData.append('login', getters.LOGIN);
            formData.append('password', getters.PASSWORD);

            state.isLoad = true;
            let {data} = await rootGetters.getHttpClient.post('/login', formData);
            state.isLoad = false;

            if (data.status == 'success') {
                state.isFail = false;
                commit('setIsLogin', true, {root: true});
                commit('setName', data.name, {root: true});
                commit('setSecondName', data.secondName, {root: true});
                commit('setUserData', data.userData, {root: true});
                commit('setAuthToken', data.authToken, {root: true});
                commit('setAllowSection', data.allowSection, {root: true});
                localStorage.authToken = data.authToken;
                localStorage.name = data.name;
                localStorage.secondName = data.secondName;
                localStorage.allowSection = data.allowSection;
                await payload.th.$store.dispatch('getSectionList', {th: payload.th})
            } else {
                state.isFail = true;
            }
        }
    }
}